import styled from 'styled-components';

type StyledSliderProps = {
  brandColor?: string;
  textColor?: string;
};

export const StyledSlider = styled.div<StyledSliderProps>`
  --default-brand-color: ${({ brandColor }) => brandColor || '#E50914'};
  --default-button-text-color: ${({ textColor }) => textColor || '#fff'};
  display: flex;
  align-items: center;
  width: 70%;
  .slider-root {
    position: relative;
    display: flex;
    align-items: center;
    user-select: none;
    touch-action: none;
    width: 100%;
    height: 20px;
    margin: 30px 12px 30px 12px;
  }

  .slider-track {
    background-color: #cfd7df;
    position: relative;
    flex-grow: 1;
    border-radius: 9999px;
    height: 6px;
    .marker-wrap {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-top: 15px;
      .marker {
        color: #12344d;
        margin-right: -0.625rem;
        position: absolute;
        display: flex;
        justify-content: space-evenly;
        opacity: 0.5;
        font-weight: 400;
        font-size: 14px;
        width: 16px;
        &.active {
          opacity: 1;
          font-weight: 600;
        }
      }
    }
  }

  .slider-range {
    position: absolute;
    background-color: var(--default-brand-color);
    border-radius: 9999px;
    height: 100%;
  }

  .slider-thumb {
    display: block;
    width: 12px;
    height: 12px;
    background-color: white;
    box-shadow: 0 0 0 4px var(--default-brand-color);
    border-radius: 10px;
    .thumb-hover {
      display: none;
      position: absolute;
      top: -28px;
      background: var(--default-brand-color);
      padding: 2px 7px;
      color: var(--default-button-text-color);
      border-radius: 5px;
      font-size: 12px;
      font-weight: 500;
      &:after {
        content: '';
        position: absolute;
        top: 100%;
        left: 50%;
        margin-left: -5px;
        border-width: 5px;
        border-style: solid;
        border-color: var(--default-brand-color) transparent transparent
          transparent;
      }
    }
    &:hover,
    &:focus {
      outline: none;
      box-shadow: 0 0 0 3px white;
      background-color: var(--default-brand-color);
      .thumb-hover {
        display: block;
      }
    }
  }
  .slider-input {
    margin-left: 30px;
    width: auto;
    text-align: center;
    border-radius: 4px;
    border: 1px solid #cfd7df;
    background: #fff;
    min-width: 50px;
    padding: 6px 10px;
    white-space: nowrap;
    flex: 1 1 80px;
  }
`;
